import { render, staticRenderFns } from "./shops.vue?vue&type=template&id=a0fcb64e&scoped=true&"
import script from "./shops.vue?vue&type=script&lang=js&"
export * from "./shops.vue?vue&type=script&lang=js&"
import style0 from "./shops.vue?vue&type=style&index=0&id=a0fcb64e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fcb64e",
  null
  
)

export default component.exports